import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Badge, List, Typography } from 'antd';

import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function Subscriptions() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);

  const recurringDateChange = (notifications || []).find(n => n.type === ENotificationType.RECURRING_DATE_CHANGE);
  if (!recurringDateChange?.quantity) return null;

  return (
    <Link to={`/producer/notifications/${ENotificationType.RECURRING_DATE_CHANGE}`}>
      <List.Item extra={<Badge count={recurringDateChange?.quantity || 0} color='blue' showZero />}>
        <Typography.Text strong>Assinaturas</Typography.Text>
      </List.Item>
    </Link>
  );
}
